import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { GraphData } from '../donut-graph-data';
import { CommonModule } from '@angular/common';
import { HighchartsService } from 'app/shared/tools/services/kla.highcharts.service';


@Component({
  selector: 'kla-action-plan-progress-chart-donut-graph',
  templateUrl: './action-plan-progress-chart-donut-graph.component.html',
  styleUrls: ['./action-plan-progress-chart-donut-graph.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class ActionPlanProgressChartDonutGraphComponent implements OnInit {

  @Input() data: GraphData[];

  constructor(private highchartsService: HighchartsService) {}

  getMappedGraphData() {
    let graphData = [];
    for(const element of this.data) {
      const mappedData = {
        name: element.title,
        y: parseFloat(element?.percentage)
      }
      graphData.push(mappedData)
    }
    return graphData;
  }

  ngOnInit(): void {
    setTimeout(() => {
      Highcharts.chart('donut-chart-container', {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent'
      },
      title: {
        text: 'Action Plan Progress'
      },
      accessibility: {
        description: 'Action plan progress donut chart showing percentage completion by category'
      },
      tooltip: {
        valueSuffix: '%'
    },
      plotOptions: {
        pie: {
          shadow: false,
          enableMouseTracking: true,
          colors: ['#35c13b', '#ffc10c', '#0265cf', '#ed30ae', '#1d455e', '#f08f20']
        }
      },
      series: [{
        type: 'pie',
        name: 'Percentage',
        data: this.getMappedGraphData(),
        innerSize: '60%'
      }],
      credits: {
        enabled: false
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 400
            },
          }
        ]
      }
    });
  })
  }
}
